import { ReactComponent as Loading } from '$icons/loading-buffer.svg';
import classes from './SingleAttachmentSummary.module.css';

export enum IconValidColorsType {
  YELLOW = 'yellow',
  BLUE = 'blue',
  GREEN = 'green',
}

interface SingleAttachmentSummaryInterface {
  icon: any;
  title: string;
  color: IconValidColorsType;
  link?: string;
  behanceFix?: boolean;
  onClick?: () => void;
  additionalClassNames?: string;
  segmentEvent?: () => void;
}

const SingleAttachmentSummary = ({
  link,
  onClick,
  icon,
  title,
  color,
  behanceFix,
  additionalClassNames,
  segmentEvent,
}: SingleAttachmentSummaryInterface) => {
  let iconBackgroundColor;

  if (link && !link?.startsWith('http:') && !link?.startsWith('https:')) {
    link = `//${link}`;
  }

  if (color === IconValidColorsType.YELLOW) {
    iconBackgroundColor = classes.singleAttachmentSummaryIconYellow;
  } else if (color === IconValidColorsType.BLUE) {
    iconBackgroundColor = classes.singleAttachmentSummaryIconBlue;
  } else {
    iconBackgroundColor = classes.singleAttachmentSummaryIconGreen;
  }

  const onClickHandler = (ev: any) => {
    if (!link || link === '') ev.preventDefault();
    if (onClick) onClick();
    if (segmentEvent) segmentEvent();
  };

  return (
    <div className={additionalClassNames}>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        style={{ display: 'flex', alignSelf: 'self-start' }}
        onClick={onClickHandler}
      >
        <div className={classes.singleAttachmentSummaryContainer}>
          <div
            className={`${
              classes.singleAttachmentSummaryIcon
            } ${iconBackgroundColor} ${
              behanceFix ? classes.behanceIconFix : ''
            }`}
          >
            {icon}
          </div>
          <div className={classes.singleAttachmentSummaryInfoContainer}>
            <div
              className={`capitalize ${classes.singleAttachmentSummaryTitle}`}
            >
              {title}
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

SingleAttachmentSummary.defaultProps = {
  link: '',
  behanceFix: false,
  onClick: () => {},
  additionalClassNames: '',
  segmentEvent: () => {},
};

export default SingleAttachmentSummary;

export const SingleAttachmentSummaryLoading = ({
  additionalClassNames,
}: {
  additionalClassNames?: string;
}) => {
  return (
    <div className={additionalClassNames}>
      <div
        className={`animate-pulse ${classes.singleAttachmentSummaryContainer}`}
      >
        <div
          className={`${classes.singleAttachmentSummaryIcon} ${classes.singleAttachmentSummaryIconBlue}`}
          style={{ padding: '10px' }}
        >
          <Loading />
        </div>
        <div className={classes.singleAttachmentSummaryInfoContainer}>
          <div className={`capitalize ${classes.singleAttachmentSummaryTitle}`}>
            Loading...
          </div>
        </div>
      </div>
    </div>
  );
};

SingleAttachmentSummaryLoading.defaultProps = {
  additionalClassNames: '',
};
